"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BookFill = {
  name: 'book',
  theme: 'fill',
  nameWithTheme: 'book-fill',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z'
    },
    children: []
  }]
};
exports.default = BookFill;